import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/barefoot.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/blue-tent.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/bookster.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/boost.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/ciirus.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/escapia.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/guesty.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/hostaway.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/hostfully-logo-long.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/inhabit.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/lightmaker.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/live-list.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/live-rez.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/lodgify-logo-long.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/lodgix.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/next-pax.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/ownerrez-logo-long.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/quick-connect.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/streamline.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/track.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/vacay-home.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/integrations/vrm.png");
